module.exports = __webpack_public_path__ + "img/countdowns.87bdea14.svg";